/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Online_OnlyInputs */



/**
* | output |
* | --- |
* | "Only" |
*
* @param {Tournaments_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_online_only = /** @type {((inputs?: Tournaments_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Online_OnlyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Uniquement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo")
	return /** @type {LocalizedString} */ ("Only")
});